<div class="d-flex flex-wrap justify-content-center align-items-center">
  <div class="">
    <span class="loading text-upper fg-accent1"> Loading </span>
  </div>
  <div class="progressbar mx-5">
    <div class="progress bg-accent1"></div>
  </div>
</div>
